var _rect, _g, _g2, _g3, _rect2, _rect3, _g4, _rect4, _path, _rect5, _path2, _rect6, _path3, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSonicAdvantageTeaser02Big(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 543 358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 433,
    height: 358,
    x: 110,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 433,
    height: 358,
    fill: "#fff",
    rx: 28,
    transform: "matrix(-1 0 0 1 543 0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 414.705,
    cy: 412.936,
    fill: "url(#b)",
    rx: 414.705,
    ry: 412.936,
    transform: "matrix(-1 0 0 1 948.771 -255.341)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381,
    height: 283,
    x: 68,
    y: 41,
    fill: "#fff",
    rx: 8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.4,
    d: "M72 58c0-6.627 5.373-12 12-12h349c6.627 0 12 5.373 12 12v246c0 6.627-5.373 12-12 12H84c-6.627 0-12-5.373-12-12V58Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 186,
    height: 27,
    x: 166,
    y: 174,
    fill: "#fff",
    rx: 13.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    x: 236,
    y: 113,
    fill: "#fff",
    rx: 23
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 222,
    x: 46,
    y: 25,
    fill: "#fff",
    rx: 8
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 65,
    x: 52,
    y: 33,
    fill: "#EEE",
    rx: 9.161
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0F33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M83 49.333v3.334m0 26.666v3.334M69.668 66h-3.333m7.19-9.477-2.357-2.357m21.31 2.358 2.357-2.358m-21.31 21.317-2.357 2.357m21.31-2.357 2.357 2.357M99.667 66h-3.333m-5 0a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 64,
    x: 52,
    y: 104,
    fill: "#EEE",
    rx: 9.161
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0F33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M83 129.864v7.636h5.77M98 136c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 65,
    x: 52,
    y: 174,
    fill: "#EEE",
    rx: 9.161
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A0F33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M89.325 221.125H74.263c-.984 0-1.476 0-1.704-.195a.811.811 0 0 1-.282-.681c.023-.299.371-.647 1.067-1.343l13.818-13.818c.643-.643.965-.965 1.336-1.085a1.626 1.626 0 0 1 1.004 0c.371.12.693.442 1.337 1.085l6.286 6.287v1.95m-7.8 7.8c2.73 0 4.095 0 5.138-.531a4.881 4.881 0 0 0 2.13-2.131c.532-1.043.532-2.408.532-5.138m-7.8 7.8h-13.65c-2.73 0-4.095 0-5.138-.531a4.881 4.881 0 0 1-2.13-2.131c-.532-1.043-.532-2.408-.532-5.138v-13.65c0-2.73 0-4.095.531-5.138a4.881 4.881 0 0 1 2.13-2.131c1.044-.531 2.409-.531 5.139-.531h13.65c2.73 0 4.095 0 5.138.531a4.881 4.881 0 0 1 2.13 2.131c.532 1.043.532 2.408.532 5.138v13.65m-17.063-12.513a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 477,
    height: 19,
    x: 20,
    y: 315,
    fill: "#fff",
    rx: 8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 421,
    height: 323,
    x: 48,
    y: 25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 381,
    height: 278,
    x: 68,
    y: 42,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 114,
    height: 262,
    x: 26,
    y: 9,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 517,
    height: 59,
    x: 0,
    y: 299,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_7523"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_7523",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 736.469,
    x2: 681.173,
    y1: 92.756,
    y2: 625.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2B4190"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A9CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 258.5,
    x2: 258.5,
    y1: 46,
    y2: 316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3866C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3866C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonicAdvantageTeaser02Big);
export default __webpack_public_path__ + "static/media/sonic-advantage-teaser-02-big.cd0614ab4372e2fdefe6afe215346d92.svg";
export { ForwardRef as ReactComponent };